// extracted by mini-css-extract-plugin
export default {"datePicker":"SingleOrRangeDatePicker__datePicker__eY8Vf"};